import { Controller } from "@hotwired/stimulus";

// Add/remove "included features" rows on the POS product detail page. "Add" clones the hidden <template>
// row and appends it; "Remove" drops a row. The empty-state hint toggles with the row count. Each row's
// inputs submit as an array of { icon, description } hashes; a separate presence marker (in the view)
// makes an emptied list still submit so the list can be cleared.
export default class extends Controller {
  static targets = ["rows", "template", "empty"];

  add() {
    const clone = this.templateTarget.content.firstElementChild.cloneNode(true);
    this.rowsTarget.appendChild(clone);
    this.updateEmpty();
    const input = clone.querySelector("input");
    if (input) input.focus();
  }

  remove(event) {
    const row = event.target.closest("[data-admin--pos-inclusion-list-target='row']");
    if (row) row.remove();
    this.updateEmpty();
  }

  updateEmpty() {
    if (this.hasEmptyTarget) {
      this.emptyTarget.classList.toggle("hidden", this.rowsTarget.children.length > 0);
    }
  }
}
